export default {
  TableHeadResetSubPassLog: [
    [
      {
        displayName: 'report.depositWithdraw.datatable.number',
      },
      {
        displayName: 'reset_subpass_log.operator',
      },
      {
        displayName: 'reset_subpass_log.user',
      },
      {
        displayName: 'reset_subpass_log.timestamp',
      },
    ],
  ],
};
